import { AuthRepository } from '../repositories/auth_repository';

/**
 * Caso de uso para realizar logout
 */
export class LogoutUseCase {
  constructor(private authRepository: AuthRepository) {}

  async execute(): Promise<void> {
    try {
      await this.authRepository.logout();
      await this.authRepository.persistToken(null);
    } catch (error) {
      throw new Error(`Logout failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}
